var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.999 3.333c-4.367 0-7.917 3.55-7.917 7.917 0 4.283 3.35 7.75 7.717 7.9.133-.017.266-.017.366 0h.117a7.897 7.897 0 0 0 7.633-7.9c0-4.367-3.55-7.917-7.916-7.917Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.466 23.583c-4.65-3.1-12.234-3.1-16.917 0C4.432 25 3.266 26.916 3.266 28.966s1.166 3.95 3.266 5.35c2.334 1.567 5.4 2.35 8.467 2.35s6.133-.783 8.467-2.35c2.1-1.416 3.266-3.317 3.266-5.383-.016-2.05-1.166-3.95-3.266-5.35Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.316 12.233c.266 3.233-2.034 6.067-5.217 6.45h-.083c-.1 0-.2 0-.284.034-1.616.083-3.1-.434-4.216-1.384 1.716-1.533 2.7-3.833 2.5-6.333a7.734 7.734 0 0 0-1.284-3.633 5.957 5.957 0 0 1 2.117-.584c3.267-.283 6.183 2.15 6.467 5.45Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.65 27.65c-.134 1.617-1.167 3.017-2.9 3.967-1.667.917-3.767 1.35-5.85 1.3 1.2-1.083 1.9-2.433 2.033-3.867.167-2.066-.817-4.05-2.783-5.633-1.117-.883-2.417-1.583-3.834-2.1 3.684-1.067 8.317-.35 11.167 1.95C36.016 24.5 36.8 26.05 36.65 27.65Z",
    fill: "currentColor"
  })));
};
export default SvgPeople;